/** `useKeyboardInsetVar` 가 documentElement 인라인 스타일에 발행하는 CSS 변수 이름. */
export const KEYBOARD_INSET_VAR = '--virtual-keyboard-height';

/**
 * 가상 키보드 인셋이 현재 발행 중인지 — 셸이 일시 축소된 상태인지 판별한다.
 *
 * 발행처가 `document.documentElement.style.setProperty` 이므로 인라인 스타일을 직접 읽는다
 * (`getComputedStyle` 과 달리 스타일 재계산을 강제하지 않아 ResizeObserver 콜백에서 안전).
 */
export function isKeyboardInsetActive(): boolean {
  if (typeof document === 'undefined') return false;
  return parseFloat(document.documentElement.style.getPropertyValue(KEYBOARD_INSET_VAR)) > 0;
}
